import React from "react";

import dayjs from "dayjs";
import "react-select/dist/react-select.css";
import { getArticles } from "@shared/scripts/features/api";
import Swiper from "swiper";
import { isMobile as isM } from "@shared/scripts/utils/tool";
import HomeCenterCard from "./HomeCenterCard";
import HomeCenterProCard from "./HomeCenterProCard";
import LevelCard from "./LevelCard";
import loadingGif from "home-center-loading.gif";
import arrowImg from "right-arrow.png";
// import circleArrowImg from "circle-right-arrow.png";
import ArrowHoverImg from "circle-right-arrow-hover.png";
// import abilityImg from "menu-ability.png";
import projectImg from "home-center-project.png";
import loveImg from "home-center-love.png";

class HomeCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: [],
      xtList: [],
      xtCount: 0,
      projectList: [],
      projectCount: 0,
      totalCount: 0,
      elapsedDays: 0,
      articlesLoading: true,
      xtLoading: true,
      projectLoading: true,
      hoveredIndex: null,
      xtHoveredIndex: null, //要区分
      projectHoveredIndex: null, //要区分
      isMobile: isM(),
      animatedNumbers: {},
    };
    this.numberAnimations = {};
    this.numberAnimationFrameId = null;
    window.addEventListener("resize", () => {
      // 获取已创建的Swiper实例
      // const swiperInstance = document.querySelector("#js-sota-project").swiper;
      // // 先销毁已有实例
      // if (swiperInstance) {
      //   swiperInstance.destroy(true, false);
      // }
      this.setState({
        isMobile: isM(),
      });
      if (isM()) {
        // 创建swiper
        new Swiper("#js-sota-project", {
          autoplay: true,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
          },
        });
      }
    });
    this.elementRef = React.createRef(); //要区分
  }

  componentDidMount() {
    this.fetchArticles();
    this.fetchXtList();
    this.fetchProjectList();
  }

  componentWillUnmount() {
    if (this.numberAnimationFrameId) {
      window.cancelAnimationFrame(this.numberAnimationFrameId);
      this.numberAnimationFrameId = null;
    }
    this.numberAnimations = {};
  }

  // 数字递增动画（统一调度，避免多次 setState 导致卡顿）
  animateNumber = (key, targetValue, duration = 1200) => {
    const target = Number(targetValue) || 0;
    this.numberAnimations[key] = {
      target,
      duration,
      startTime: performance.now(),
      lastValue: -1,
    };
    if (!this.numberAnimationFrameId) {
      this.numberAnimationFrameId = window.requestAnimationFrame(
        this.runNumberAnimations
      );
    }
  };

  runNumberAnimations = now => {
    const nextAnimatedNumbers = {};
    let hasActiveAnimation = false;
    Object.keys(this.numberAnimations).forEach(key => {
      const animation = this.numberAnimations[key];
      if (!animation) return;
      const progress = Math.min(
        (now - animation.startTime) / animation.duration,
        1
      );
      const currentValue = Math.round(
        animation.target * (1 - (1 - progress) * (1 - progress))
      );
      if (currentValue !== animation.lastValue) {
        nextAnimatedNumbers[key] = currentValue;
        animation.lastValue = currentValue;
      }
      if (progress < 1) {
        hasActiveAnimation = true;
      } else {
        delete this.numberAnimations[key];
      }
    });
    if (Object.keys(nextAnimatedNumbers).length > 0) {
      this.setState(prev => ({
        animatedNumbers: {
          ...prev.animatedNumbers,
          ...nextAnimatedNumbers,
        },
      }));
    }
    if (hasActiveAnimation) {
      this.numberAnimationFrameId = window.requestAnimationFrame(
        this.runNumberAnimations
      );
    } else {
      this.numberAnimationFrameId = null;
    }
  };

  getAnimatedNumber = (key, fallbackValue = 0) => {
    const animatedValue = this.state.animatedNumbers[key];
    if (typeof animatedValue === "number") {
      return animatedValue;
    }
    return Number(fallbackValue) || 0;
  };

  // 判断是否是今天
  isToday = publish => {
    const publishDate = publish.toString().slice(0, 10);
    const today = dayjs(Date.now())
      .format("YYYY/MM/DD")
      .toString();
    return publishDate === today ? "今天" : dayjs(publish).format("MM月DD日");
  };

  // 计算时间差，并换算为对应格式
  timeDiff = publish => {
    const difference = Date.now() - Date.parse(publish);
    const seconds = difference / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const now = new Date(publish);
    const timeYear = now.getFullYear();
    const timeMonth = now.getMonth() + 1;
    const timeDay = now.getDate();
    const timeStr =
      seconds < 60
        ? "刚刚"
        : minutes < 60
        ? `${Math.floor(minutes)}分钟前`
        : hours < 24
        ? `${Math.floor(hours)}小时前`
        : days < 7
        ? `${Math.floor(days)}天前`
        : timeYear === new Date().getFullYear()
        ? `${timeMonth}月${timeDay}日`
        : `${timeYear}年${timeMonth}月${timeDay}日`;
    return timeStr;
  };

  fetchArticles() {
    this.setState({
      articlesLoading: true,
    });
    getArticles().done(res => {
      const elapsedDays = res.elapsedDays || 0;
      const totalCount = res.publishedArticlesCount || 0;
      const isMobile = isM();
      this.setState({
        articles: res.articles,
        totalCount,
        elapsedDays,
        articlesLoading: false,
      });
      if (!isMobile) {
        this.animateNumber("elapsedDays", elapsedDays);
        this.animateNumber("totalCount", totalCount, 1400);
      }
    });
  }

  fetchXtList() {
    // const url = "api/v3/sota/chat_sets/sidebar";
    $.ajax({
      url: "https://sota.jiqizhixin.com/api/v3/sota/chat_sets/list",
      // url: window.location.hostname.includes("localhost")
      //   ? `https://sota.almosthuman.cn/${url}`
      //   : `${window.location.origin}/${url}`,
      method: "GET",
      datType: "json",
      success: response => {
        this.setState({
          xtList:
            response.chatSets && response.chatSets.length > 0
              ? response.chatSets.slice(0, 8)
              : [], // 设置数据
          xtCount: response.totalCount || 0,
          xtLoading: false, // 设置加载状态为 false
        });
        if (!this.state.xtLoading && this.state.xtList.length > 0) {
          new Swiper("#js-sota-xt", {
            autoplay: true,
            // autoplay: {
            //   delay: 3000,
            //   stopOnLastSlide: false,
            //   disableOnInteraction: true,
            // },
            loop: true,
            pagination: {
              el: ".swiper-pagination",
            },
          });
        }
      },
      error: (xhr, status, error) => {
        console.log("error", error);
        this.setState({
          xtLoading: false, // 设置加载状态为 false
        });
      },
    });
  }

  fetchProjectList() {
    $.ajax({
      url:
        "https://sota.jiqizhixin.com/api/v2/sota/terms?order=generationAt&per=8&page=1",
      method: "GET",
      datType: "json",
      success: response => {
        this.setState({
          projectList:
            response.data && response.data.length > 0 ? response.data : [], // 设置数据
          projectCount: response.realTotalCount || 0,
          projectLoading: false, // 设置加载状态为 false
        });
        this.animateNumber("projectCount", response.realTotalCount || 0, 1400);
        if (!this.state.projectLoading && this.state.projectList.length > 0) {
          new Swiper("#js-sota-project", {
            autoplay: true,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
            },
          });
        }
      },
      error: (xhr, status, error) => {
        console.log("error", error);
        this.setState({
          projectLoading: false, // 设置加载状态为 false
        });
      },
    });
  }

  jumpToXt() {
    window.open(`https://sota.jiqizhixin.com/xt-terminal`, "_blank");
  }

  jumpToProject() {
    window.open(`https://sota.jiqizhixin.com`, "_blank");
  }

  render() {
    const {
      articlesLoading,
      // xtLoading,
      projectLoading,
      articles,
      elapsedDays,
      totalCount,
      hoveredIndex,
      xtHoveredIndex,
      // xtList,
      // xtCount,
      projectList,
      projectCount,
      isMobile,
    } = this.state;
    return (
      <div className="home__center">
        {articlesLoading && projectLoading ? (
          <div className="home__center-loading">
            <img src={loadingGif} alt="loadings" />
          </div>
        ) : (
          <>
            {/* home__center-left放在外边占位，防止左边未加载出来时页面跑偏 */}
            <div className="home__center-left">
              {articles && articles.length > 0 && (
                <>
                  <div className="home__center-left-header">
                    <div className="home__center-left-title">
                      <div>文章库</div>
                      <p>
                        已追踪 AI 发展{" "}
                        <span>
                          {this.getAnimatedNumber("elapsedDays", elapsedDays)}
                        </span>{" "}
                        天，
                        <span>
                          {this.getAnimatedNumber("totalCount", totalCount)}
                        </span>{" "}
                        篇原创内容
                      </p>
                    </div>
                    <div
                      className="home__center-more"
                      onClick={() => window.open(`/articles`, "_blank")}
                    >
                      {/* <img
                        className="home__center-more__arrow"
                        src={circleArrowImg}
                        alt="arrow"
                      /> */}
                      <img
                        className="home__center-more__hover"
                        src={ArrowHoverImg}
                        alt="arrow"
                      />
                    </div>
                  </div>
                  <div className="home__center-left__list">
                    {!isMobile && <div className="home__center-left__hover" />}
                    {articles.slice(0, 12).map((item, index) => (
                      <HomeCenterCard
                        key={item.id}
                        type="left"
                        hoveredIndex={hoveredIndex}
                        index={index}
                        initTop={-2} //文章库列表，设计的hover效果，比实际card上下各多2px，因此要向上偏移2px
                      >
                        <div
                          className="home__article-item"
                          key={index}
                          ref={this.elementRef}
                          onMouseEnter={() =>
                            this.setState({ hoveredIndex: index })
                          }
                          onMouseLeave={() =>
                            this.setState({ hoveredIndex: null })
                          }
                          onClick={() => {
                            window.sessionStorage.setItem("jumpType", "home");
                            window.open(`/articles/${item.slug}`, "_blank");
                          }}
                        >
                          <div className="home__article-item__left">
                            <div
                              className={`home__article-item__title ${
                                isMobile ? "over--2" : "over--1"
                              }`}
                            >
                              {item.title}
                            </div>
                            {/* <div className="home__article-item__content over--1">
                              {item.content}
                            </div> */}
                            <div className="home__article-item__bottom">
                              <div className="home__article-item__time">
                                {this.isToday(item.publishedAt)}
                              </div>
                              {!isMobile &&
                                item.tagList &&
                                item.tagList.length > 0 && (
                                  <div className="home__article-item__tags">
                                    {item.tagList.map((tag, index) => (
                                      <div
                                        className="home__article-item__tag-item"
                                        key={index}
                                      >
                                        {tag}
                                      </div>
                                    ))}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="home__article-item__right">
                            <img src={item.coverImageUrl} alt="img" />
                          </div>
                        </div>
                      </HomeCenterCard>
                    ))}
                  </div>
                  <div
                    className="home__center-left__more"
                    onClick={() => window.open(`/articles`, "_blank")}
                  >
                    进入文章库，查阅过往文章
                    <img src={arrowImg} alt="arrow" />
                  </div>
                </>
              )}
            </div>
            <div className="home__center-right">
              {projectList && projectList.length > 0 && (
                <>
                  <div className="home__center-right-header">
                    <div className="home__center-right-title">
                      <div>最新开源</div>
                      <p>
                        已收录{" "}
                        <span>
                          {this.getAnimatedNumber("projectCount", projectCount)}
                        </span>{" "}
                        个开源项目
                      </p>
                    </div>
                    <div
                      className="home__center-more"
                      onClick={() => this.jumpToProject()}
                    >
                      {/* <img
                        className="home__center-more__arrow"
                        src={circleArrowImg}
                        alt="arrow"
                      /> */}
                      <img
                        className="home__center-more__hover"
                        src={ArrowHoverImg}
                        alt="arrow"
                      />
                    </div>
                  </div>
                  {isMobile ? (
                    <>
                      <div
                        className="swiper home__center-right__list"
                        id="js-sota-project"
                      >
                        <div className="swiper-wrapper">
                          {projectList.map((item, index) => (
                            <div
                              className="swiper-slide home__xt-item-wrapper"
                              key={index}
                            >
                              <div
                                className="home-card"
                                onClick={() => {
                                  window.open(
                                    `https://sota.jiqizhixin.com/project/${item.source.slug}`,
                                    "_blank"
                                  );
                                }}
                              >
                                <div className="home-card__header">
                                  <img src={projectImg} alt="icon" />
                                  {item.source.name && (
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: item.source.name,
                                      }}
                                    />
                                  )}
                                  {item.source.category
                                    .filter(ca => !!ca)
                                    .slice(0, 1)
                                    .map((item, index) => (
                                      <div
                                        key={index}
                                        className="home-card__type"
                                      >
                                        {item}
                                      </div>
                                    ))}
                                  <div className="home-card__star">
                                    <div className="total-number">
                                      <img src={loveImg} alt="love" />
                                      <span>{item.source.userStars}</span>
                                    </div>
                                    <div className="right-line" />
                                    <LevelCard item={item.source} />
                                  </div>
                                </div>
                                {item.source.summary && (
                                  <p
                                    className="home-card__summary"
                                    dangerouslySetInnerHTML={{
                                      __html: item.source.summary,
                                    }}
                                  />
                                )}
                                {item.source.termResourceCounts > 0 && (
                                  <div className="home-card__bottom">
                                    <div className="home-card__bottom-total">
                                      {item.source.testCounts > 0 && (
                                        <span className="light-data">
                                          <span>{item.source.testCounts}</span>
                                          条社区实测
                                        </span>
                                      )}
                                      {item.source.termResourceCounts > 0 && (
                                        <>
                                          {item.source.testCounts > 0 && (
                                            <div className="right-line" />
                                          )}
                                          <span>
                                            {item.source.termResourceCounts}
                                          </span>{" "}
                                          个资源
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="swiper-pagination" />
                      </div>
                    </>
                  ) : (
                    <div className="home__center-right__list">
                      <div className="home__center-right__hover" />
                      {projectList.map((item, index) => (
                        <HomeCenterProCard
                          key={index}
                          hoveredIndex={xtHoveredIndex}
                          type="right"
                          index={index}
                          initTop={0}
                        >
                          <div
                            className="home-card"
                            key={index}
                            ref={this.elementRef}
                            onMouseEnter={() =>
                              this.setState({ xtHoveredIndex: index })
                            }
                            onMouseLeave={() =>
                              this.setState({ xtHoveredIndex: null })
                            }
                            onClick={() => {
                              window.open(
                                `https://sota.jiqizhixin.com/project/${item.source.slug}`,
                                "_blank"
                              );
                            }}
                          >
                            <div className="home-card__header">
                              <img src={projectImg} alt="icon" />
                              {item.source.name && (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.source.name,
                                  }}
                                />
                              )}
                              {item.source.category
                                .filter(ca => !!ca)
                                .slice(0, 1)
                                .map((item, index) => (
                                  <div key={index} className="home-card__type">
                                    {item}
                                  </div>
                                ))}
                              <div className="home-card__star">
                                <div className="total-number">
                                  <img src={loveImg} alt="love" />
                                  <span>{item.source.userStars}</span>
                                </div>
                                <div className="right-line" />
                                <LevelCard item={item.source} />
                              </div>
                            </div>
                            {item.source.summary && (
                              <p
                                className="home-card__summary"
                                dangerouslySetInnerHTML={{
                                  __html: item.source.summary,
                                }}
                              />
                            )}
                            {item.source.termResourceCounts > 0 && (
                              <div className="home-card__bottom">
                                <div className="home-card__bottom-total">
                                  {item.source.testCounts > 0 && (
                                    <span className="light-data">
                                      <span>{item.source.testCounts}</span>
                                      条社区实测
                                    </span>
                                  )}
                                  {item.source.termResourceCounts > 0 && (
                                    <>
                                      {item.source.testCounts > 0 && (
                                        <div className="right-line" />
                                      )}
                                      <span>
                                        {item.source.termResourceCounts}
                                      </span>{" "}
                                      个资源
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </HomeCenterProCard>
                      ))}
                    </div>
                  )}

                  <div
                    className="home__center-right__more"
                    onClick={() => this.jumpToProject()}
                  >
                    进入SOTA！模型，查看更多开源项目
                    <img src={arrowImg} alt="arrow" />
                  </div>
                </>
              )}
              {/* {xtList && xtList.length > 0 && (
                <>
                  <div className="home__center-right-header">
                    <div className="home__center-right-title">
                      <div>尝试最新 AI 模型</div>
                      <p>
                        共接入 <span>{xtCount}</span> 个模型，选择一个开始使用
                      </p>
                    </div>
                    <div
                      className="home__center-more"
                      onClick={() => this.jumpToXt()}
                    >
                      <img
                        className="home__center-more__arrow"
                        src={circleArrowImg}
                        alt="arrow"
                      />
                      <img
                        className="home__center-more__hover"
                        src={ArrowHoverImg}
                        alt="arrow"
                      />
                    </div>
                  </div>
                  {isMobile ? (
                    <>
                      <div
                        className="swiper home__center-right__list"
                        id="js-sota-xt"
                      >
                        <div className="swiper-wrapper">
                          {xtList.map(item => (
                            <div
                              className="swiper-slide home__xt-item-wrapper"
                              key={item.id}
                              onClick={() =>
                                window.open(
                                  `https://sota.jiqizhixin.com/xt-terminal/${item.id}`,
                                  "_blank"
                                )
                              }
                            >
                              <div className="home__xt-item">
                                <div className="home__xt-item__top">
                                  <div className="home__xt-item__title">
                                    <img src={abilityImg} alt="ability" />
                                    <p className="over--1">{item.name}</p>
                                  </div>
                                  {!!item.sharedSessionsCount && (
                                    // 该频道下状态为“公开”的测例总数
                                    <div className="home__xt-item__count">
                                      {item.sharedSessionsCount} 条实测
                                    </div>
                                  )}
                                </div>
                                <div className="home__xt-item__desc over--2">
                                  {item.summary}
                                </div>
                                <div className="home__xt-item__bottom">
                                  // ready && running显示运行中
                                  <div className="home__xt-item__open">
                                    {item.ready && item.running && (
                                      <div className="home__xt-item__open-state">
                                        <span className="home__xt-item__open-dot" />
                                        运行中
                                      </div>
                                    )}
                                  </div>
                                  {item.partner && (
                                    <div
                                      className="home__xt-item__from"
                                      onClick={e => {
                                        e.stopPropagation();
                                        item.partner.website &&
                                          window.open(
                                            item.partner.website,
                                            "_black"
                                          );
                                      }}
                                    >
                                      <img
                                        src={item.partner.logoUrl}
                                        alt={item.partner.name}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="swiper-pagination" />
                      </div>
                    </>
                  ) : (
                    <div className="home__center-right__list">
                      <div className="home__center-right__hover" />
                      {xtList.map((item, index) => (
                        <HomeCenterCard
                          key={item.id}
                          hoveredIndex={xtHoveredIndex}
                          type="right"
                          index={index}
                          initTop={0}
                        >
                          <div
                            className="home__xt-item"
                            key={index}
                            ref={this.elementRef}
                            onMouseEnter={() =>
                              this.setState({ xtHoveredIndex: index })
                            }
                            onMouseLeave={() =>
                              this.setState({ xtHoveredIndex: null })
                            }
                            onClick={() => {
                              window.open(
                                `https://sota.jiqizhixin.com/xt-terminal/${item.id}`,
                                "_blank"
                              );
                            }}
                          >
                            <div className="home__xt-item__top">
                              <div className="home__xt-item__title">
                                <img src={abilityImg} alt="ability" />
                                <p className="over--1">{item.name}</p>
                              </div>
                              {!!item.sharedSessionsCount && (
                                <div className="home__xt-item__count">
                                  {item.sharedSessionsCount} 条实测
                                </div>
                              )}
                            </div>
                            <div className="home__xt-item__desc over--2">
                              {item.summary}
                            </div>
                            <div className="home__xt-item__bottom">
                              // ready && running显示运行中
                              <div className="home__xt-item__open">
                                {item.ready && item.running && (
                                  <div className="home__xt-item__open-state">
                                    <span className="home__xt-item__open-dot" />
                                    运行中
                                  </div>
                                )}
                              </div>
                              {item.partner && (
                                <div
                                  className="home__xt-item__from"
                                  onClick={e => {
                                    e.stopPropagation();
                                    item.partner.website &&
                                      window.open(
                                        item.partner.website,
                                        "_black"
                                      );
                                  }}
                                >
                                  <img
                                    src={item.partner.logoUrl}
                                    alt={item.partner.name}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </HomeCenterCard>
                      ))}
                    </div>
                  )}

                  <div
                    className="home__center-right__more"
                    onClick={() => this.jumpToXt()}
                  >
                    进入小土终端，在线实测更多模型
                    <img src={arrowImg} alt="arrow" />
                  </div>
                </>
              )} */}
            </div>
          </>
        )}
      </div>
    );
  }
}

export default HomeCenter;
